export default {
  US: "АНУ",
  ASIA: "Ази",
  EUR: "Европ",
  BONDS: "Бонд",
  CRYPTO: "Крипто",
  "FX EUR": "Валют (Европ)",
  "FX ASIA": "Валют (Ази)",
  Last: "Шинэчлэгдсэн",
  "EOD Quote": "Хаалтын ханш",
  "KEY STATS": "Үндсэн үзүүлэлтүүд",
  Open: "Нээлтийн ханш",
  "Prev Close": "Өмнөх өдрийн хаалтын ханш",
  "Day High": "Тухайн өдрийн дээд ханш",
  "%Change": "Өөрчлөлт(%)",
  "Day Low": "Тухайн өдрийн доод ханш",
  "MARKET MOVERS": "Зах зээлийг хөдөлгөгчид",
  TOP: "Хамгийн өндөр өсөлттэй хувьцаа",
  BOTTOM: "Хамгийн өндөр уналттай хувьцаа",
  "Energy Futures": "Эрчим хүчний түүхий эд (Фьючерс)",
  PRICE: "Ханш",
  SYMBOL: "Симбол",
  CHANGE: "Өөрчлөлт",
  "%CHANGE": "Өөрчлөлт (%)",
  VOLUME: "Арилжааны хэмжээ",
  "Major Currency Pairs": "Валютын ханш",
  YIELD: "Өгөөж",
  NAME: "Индикаторын нэр",
  PERIOD: "Хугацаа",
  VALUE: "Үзүүлэлт",
  "VALUE DATE": "Үзүүлэлтийн огноо",
  "PRIOR VALUE": "Өмнөх үзүүлэлт",
  "NO DATA": "Өгөгдөл байхгүй",
  "Open Interest": "Авах захиалга",
  "Exp. Date": "Дуусах огноо",
  COMDTY: "Түүхий эд",
  // 新增翻译
  "BRENT OIL": "Brent",
  "GAS OIL": " Хий",
  "CARBON EMMISSIONS": "Нүүрстөрөгчийн ялгаруулалт",
  GASOLINE: "Шатахуун",
  "RICHARD BAY COAL": "Нүүрс (Richard Bay)",
  "NEWCASTLE COAL": "Нүүрс (Newcastle)",
  "NATUAL GAS": "Байгалийн хий",
  // "WTI Crude":""
  "HEATING OIL": "Дулааны эрчим хүчний тос",
  PLATINUM: "Цагаан алт",
  COPPER: "Зэс",
  PALLADIUM: "Палладий",
  ALUMINIUM: "Хөнгөнцагаан",
  "IRON ORE": "Төмрийн хүдэр",
  GOLD: "Алт",
  SILVER: "Мөнгө",
  WHEAT: "Улаанбуудай",
  CORN: "Эрдэнэшиш",
  "ROUGH RICE": "Боловсруулаагүй цагаан будаа",
  "WHITE SUGAR 5": "Элсэн чихэр 5",
  "ROBUSTA COFFEE": "Кофе (Robusta)",
  "LONDON COCOA": "Какао (London)",
  COCOA: "Какао",
  COFFEE: "Кофе",
  COTTON: "Хөвөн",
  "SUGAR 11": "Элсэн чихэр 11",
  "SUGAR 16": "Элсэн чихэр 16",
  CANOLA: "Канола",
  "ORANGE JUICE": "Жүржийн шүүс",
};
